
import React, { useEffect, useState } from "react";
import MainTable from "../../../../components/mainTable";
import { MedicationRequest } from "../../../../interfaces/pharmacy";
import { services } from "../../../../api";
import { getMedicationRequestsColumns } from "../../../../shared/tableColumns/medicationRequestsColumns";
import { toastService } from "../../../../shared/utils/toast";

const ApproveMedicationRequests: React.FC = () => {
  const [data, setData] = useState<MedicationRequest[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  const fetchRequests = async () => {
    setIsLoading(true);
    try {
      const response: any = await services.pharmacy.getMedicationRequests();
      if (response.result === "success") {
        setData(response.content.data);
        setTotal(response.content.total);
      }
    } catch (error) {
      console.error("Failed to fetch medication requests:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, [page, rowsPerPage]);

  const handleApprove = (request: MedicationRequest) => {
    toastService.showSuccessToast("Request approved successfully!");
    setData(prevData => prevData.filter(item => item.id !== request.id));
  };

  const handleReject = (request: MedicationRequest) => {
    toastService.showErrorToast("Request rejected.");
    setData(prevData => prevData.filter(item => item.id !== request.id));
  };

  const columns = getMedicationRequestsColumns(
    handleApprove,
    handleReject
  );

  const handlePageChange = (event: { pageIndex: number; pageSize: number }) => {
    setPage(event.pageIndex);
    setRowsPerPage(event.pageSize);
  };

  return (
    <div className="p-4">
        <MainTable
            data={data}
            columns={columns}
            isLoading={isLoading}
            showPagination={true}
            totalData={total}
            pageSize={rowsPerPage}
            currentPage={page}
            onPageChanged={handlePageChange}
            showSearch={true}
        />
    </div>
  );
};

export default ApproveMedicationRequests; 